import React, { useState } from 'react'
import "./layout.css";
import { Typography } from 'antd';

const PTRPortalFooter = () => {
    const { Text } = Typography;

    return (
        <>
            <div className='portal-footer'>
                <div className='content'>
                    <Text style={{ color: 'var(--description-text)' }}>© 2025 Paysign, Inc. All rights reserved</Text>
                </div>
            </div>
        </>
    )
}

export default PTRPortalFooter